module.exports = __webpack_public_path__ + "img/gb102.prt.95d58217.jpg";